import {InjectionToken} from '@angular/core';
import {DcpDataService} from '../dcp-data.service';
import {DcpEddlCollectorService} from './dcp-eddl-collector.service';

export const DCP_EDDL_DATA_LAYER_SERVICE = new InjectionToken<DcpDataService<DcpEddlCollectorService>>('DCP_EDDL_DATA_LAYER_SERVICE');
